import { render, staticRenderFns } from "./Official_Count.vue?vue&type=template&id=9309bc8a&scoped=true"
import script from "./Official_Count.vue?vue&type=script&lang=js"
export * from "./Official_Count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9309bc8a",
  null
  
)

export default component.exports